import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import React, { ChangeEvent, FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
    ButtonsContainer,
    Container,
    EmptyError,
    InputContainer,
    InputPlaceholder,
    Label,
    Name,
    RightIcon
} from './PersonalInfoForm.style'
import FlexContainer from '../style/FlexContainer.style'

interface Props {
    name: string
    setName: (name: string) => void
    lastName: string
    setLastName: (lastName: string) => void
    loading: boolean
    onSubmit: () => void
    onCancelClick: () => void
}

const PersonalInfoForm: FC<Props> = ({ name, setName, lastName, setLastName, onSubmit, onCancelClick, loading }) => {
    const { t } = useTranslation()
    const [editable, setEditable] = useState(false)

    const onSubmitClick = () => {
        if (editable) {
            onSubmit()
            setEditable(false)
            // remove focus on button
            const button = document.getElementById('submit-button')
            if (button) {
                button.blur()
            }
        } else {
            setEditable(true)
        }
    }

    return (
        <Container>
            <FlexContainer justifycontent="space-between">
                <Name>{t('profile.name')}</Name>
                {!editable && (
                    <RightIcon
                        className="wemolo-edit minor-hover-effect"
                        onClick={() => {
                            setEditable(true)
                        }}
                    />
                )}
            </FlexContainer>
            <div>
                <InputPlaceholder>{t('register.name')}</InputPlaceholder>
                {editable ? (
                    <InputContainer
                        type="text"
                        value={name}
                        $error={!loading && !name}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setName(e.target.value)
                        }}
                        placeholder={t('register.yourName')}
                    />
                ) : (
                    <Label>{name}</Label>
                )}
                {editable && !loading && !name && <EmptyError>{t('profile.emptyName')}</EmptyError>}
            </div>
            <div>
                <InputPlaceholder>{t('register.lastName')}</InputPlaceholder>
                {editable ? (
                    <InputContainer
                        type="text"
                        value={lastName}
                        $error={!loading && !lastName}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setLastName(e.target.value)
                        }}
                        placeholder={t('register.yourLastName')}
                    />
                ) : (
                    <Label>{lastName}</Label>
                )}
                {editable && !loading && !lastName && <EmptyError>{t('profile.emptyLastName')}</EmptyError>}
            </div>

            {editable && (
                <ButtonsContainer>
                    <Button
                        id="submit-button"
                        type="submit"
                        isLoading={loading}
                        disabled={!name || !lastName}
                        $size={BUTTON_SIZE.medium}
                        $kind={BUTTON_KIND.primary}
                        overrides={{
                            BaseButton: {
                                style: {
                                    width: '100%'
                                }
                            }
                        }}
                        onClick={onSubmitClick}
                    >
                        <div>{t('profile.submitProfileChange')}</div>
                    </Button>
                    <Button
                        id="cancel-button"
                        type="submit"
                        disabled={loading}
                        $size={BUTTON_SIZE.medium}
                        $kind={BUTTON_KIND.ghost}
                        overrides={{
                            BaseButton: {
                                style: {
                                    width: '100%'
                                }
                            }
                        }}
                        onClick={() => {
                            setEditable(false)
                            onCancelClick()
                        }}
                    >
                        <div>{t('common.cancel')}</div>
                    </Button>
                </ButtonsContainer>
            )}
        </Container>
    )
}

export default PersonalInfoForm
